/* crid-geo.js — le visiteur arrive dans SA langue et SA devise, tout seul.
 *
 * Demande du patron : « si l'utilisateur vient d'un pays tu mets automatiquement sa langue et
 * sa devise ». On s'appuie sur l'endpoint natif de Shopify Markets, jamais sur un service
 * d'IP tiers : `/browsing_context_suggestions.json` croise l'IP (pays → devise) et
 * l'en-tête Accept-Language (langue), et il ne propose QUE ce que la boutique sait servir.
 * Un Français de passage au Japon obtient donc des prix en yens, en français.
 *
 * ⛔ CINQ GARDE-FOUS. Chacun répare un dégât possible :
 *
 *  1. LES ROBOTS NE SONT JAMAIS REDIRIGÉS. Googlebot explore depuis les États-Unis : le
 *     rediriger casserait l'indexation des 14 langues et les hreflang posés hier. C'est le
 *     garde-fou le plus important du fichier.
 *  2. UNE SEULE FOIS. Un drapeau est posé après le premier passage, et AUSSI dès que le
 *     visiteur touche lui-même le sélecteur du pied de page. Sans ça, quelqu'un qui choisit
 *     « France » depuis le Japon se ferait renvoyer au japonais à chaque page.
 *  3. JAMAIS SI L'URL PORTE DÉJÀ UNE LANGUE. `/ja/...` veut dire que le visiteur (ou Google)
 *     a demandé cette version. On n'y touche pas — et ça supprime tout risque de boucle.
 *  4. JAMAIS PENDANT UN ACHAT. /checkout, /cart, /account : on ne s'interpose pas.
 *  5. `?nogeo=1` désarme tout, pour pouvoir tester le site tel qu'un étranger le voit.
 */
(function () {
  'use strict';

  var CFG;
  try { CFG = JSON.parse(document.getElementById('cridGeoCfg').textContent); } catch (e) { return; }

  var CLE = 'cridGeo';

  /* 18/08 — LA LANGUE SUIT LE PAYS, plus l'en-tête Accept-Language du navigateur.
     Un Allemand dont le téléphone est réglé en anglais doit lire l'allemand : c'est là qu'il
     achète. Les 26 pays sont ceux des marchés de la boutique, relevés dans l'admin.
     ⚠ Trois pays n'ont pas de réponse unique — arbitrage assumé, majorité linguistique :
        BE → nl (Flandre ≈ 60 %) · CH → de (≈ 62 %) · CA → en (Québec ≈ 22 %)
     Le sélecteur du pied de page reste souverain et sa décision est mémorisée. */
  var LANGUE_PAR_PAYS = {
    DE: 'de', AT: 'de', CH: 'de',
    FR: 'fr', LU: 'fr',
    BE: 'nl', NL: 'nl',
    ES: 'es', MX: 'es',
    IT: 'it',
    PT: 'pt-PT', BR: 'pt-BR',
    PL: 'pl', DK: 'da', NO: 'nb', SE: 'sv',
    JP: 'ja', TH: 'th',
    US: 'en', GB: 'en', IE: 'en', CA: 'en', AU: 'en', NZ: 'en', SG: 'en', ZA: 'en'
  };
  /* le menu du header s'en sert aussi : choisir un pays doit changer la langue avec.
     ⚠ Posée AVANT les garde-fous ci-dessous, donc disponible même si la redirection est
     désarmée (robot, ?nogeo=1, navigateur piloté). Une seule table pour les deux usages :
     deux copies finiraient par diverger, et la divergence serait invisible. */
  window.CRID_LANGUE_PAR_PAYS = LANGUE_PAR_PAYS;

  /* Le sélecteur du pied de page vaut décision humaine : on la respecte pour toujours. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && String(f.action).indexOf('/localization') > -1) {
      try { localStorage.setItem(CLE, 'manuel'); } catch (err) { /* navigation privée */ }
    }
  }, true);

  /* 1 — robots */
  var UA = navigator.userAgent || '';
  if (/bot|crawl|spider|slurp|baidu|yandex|duckduck|bingpreview|facebookexternalhit|embedly|quora|pinterest|whatsapp|telegram|headlesschrome|lighthouse|gtmetrix|pingdom|ahrefs|semrush/i.test(UA)) return;

  /* 5 — désarmement manuel */
  if (location.search.indexOf('nogeo=1') > -1) return;

  /* 6 — NAVIGATEUR PILOTÉ. `navigator.webdriver` ne vaut true que sous automatisation
     (Playwright, Selenium, CDP). Un client ne l'a jamais. Sans ce test, la redirection
     détruit le contexte d'exécution des 32 scripts de vérification du projet — vécu le
     17/08, l'audit en 10 boucles est mort dessus à la première page. */
  if (navigator.webdriver) return;

  /* 2 — une seule fois */
  try { if (localStorage.getItem(CLE)) return; } catch (e2) { return; }

  /* 3 — l'URL porte déjà une langue → le choix est fait */
  if (CFG.root && CFG.root !== '/') return;

  /* 4 — parcours d'achat et compte */
  if (/^\/(checkout|cart|account|apps|tools|challenge)/.test(location.pathname)) return;

  var U = '/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true&currency[enabled]=true';
  fetch(U, { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (j) {
      if (!j || !j.suggestions || !j.suggestions.length) return;
      var parts = j.suggestions[0].parts || {};
      var pays = parts.country && parts.country.handle;
      /* ⛔ on N'UTILISE PLUS `parts.language` : Shopify le déduit d'Accept-Language, donc du
         réglage du téléphone, pas du pays où se trouve l'acheteur. La table tranche ; la
         suggestion ne sert plus que de repli si le pays est inconnu de la table. */
      var langue = (pays && LANGUE_PAR_PAYS[pays]) || (parts.language && parts.language.handle);

      /* on ne propose que ce que la boutique sert VRAIMENT (les listes viennent de Liquid) */
      if (pays && CFG.pays.indexOf(pays) < 0) pays = null;
      if (langue && CFG.langues.indexOf(langue) < 0) langue = null;

      /* rien à changer ? on pose quand même le drapeau : inutile de redemander à chaque page */
      var bougePays = pays && pays !== CFG.paysActuel;
      var bougeLangue = langue && langue !== CFG.langueActuelle;
      if (!bougePays && !bougeLangue) { try { localStorage.setItem(CLE, 'idem'); } catch (e3) {} return; }

      try { localStorage.setItem(CLE, 'auto'); } catch (e4) { return; }

      /* ⚠ On réutilise le formulaire du pied de page : c'est Liquid qui a rempli `return_to`,
         `_method=put` et le jeton — le reconstruire à la main, c'est se tromper un jour. */
      var f = document.getElementById('LysFooterLoc');
      if (!f) return;
      var cp = f.querySelector('[name="country_code"]');
      var cl = f.querySelector('[name="locale_code"]');
      if (bougePays && cp) cp.value = pays;
      if (bougeLangue && cl) cl.value = langue;
      /* un <select> refuse une valeur absente de ses options : on vérifie APRÈS écriture */
      if (bougePays && cp && cp.value !== pays) return;
      if (bougeLangue && cl && cl.value !== langue) return;
      f.submit();
    })
    .catch(function () { /* pas de suggestion : le site reste tel quel, c'est un repli valable */ });
})();
